import { Dayjs } from 'dayjs'
import { createContext, Dispatch, SetStateAction, useContext } from 'react'
// TODO: Import these types when qa-chat and cxgenie services are migrated
// import { ChatSession } from '../services/cxgenie/chat-session.type'
// import {
//   Conversation,
//   ConversationFilterBy,
//   ReviewStage,
//   Status,
// } from '../services/qa-chat'

// Temporary placeholder types until services are migrated
type ChatSession = any
type Conversation = any
type ConversationFilterBy = any
type ReviewStage = any
type Status = any

interface QAChatContextValues {
  conversationListParams?: any

  range?: string[] | null[]
  setRange?: Dispatch<SetStateAction<string[] | null[]>>

  sortBy?: Sorter
  setSortBy?: Dispatch<SetStateAction<Sorter>>
  filterBy?: ConversationFilterBy
  setFilterBy?: Dispatch<SetStateAction<ConversationFilterBy>>
  search?: string
  searchKeyDebounce?: string
  setSearch?: Dispatch<SetStateAction<string | undefined>>
  handleChangeDateRange?: (range?: [Dayjs | null, Dayjs | null]) => void
  handleChangeStatus?: (status: Status) => void
}

// For UI purpose only
interface QAScoreContextValues {
  currentStage?: ReviewStage
  setCurrentStage?: Dispatch<SetStateAction<ReviewStage | undefined>>
}

interface ConversationContextValues {
  selectedConversation?: Conversation
  selectedChatSession?: ChatSession | null
}

export const QAChatContext = createContext<QAChatContextValues>({})

export const QAScoreContext = createContext<QAScoreContextValues>({})

export const ConversationContext = createContext<ConversationContextValues>({})

export const useQAChatContext = () => {
  return useContext(QAChatContext)
}

export const useQAScoreContext = () => {
  return useContext(QAScoreContext)
}

export const useConversationContext = () => {
  return useContext(ConversationContext)
}
